import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Header, Form, Button, Message } from 'semantic-ui-react';
import config from 'config/config';
import { setIntraLoggedIn } from './intraAuth';

const IntraView: React.FC = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        if (password === config.INTRA_PASSWORD && username === config.INTRA_USERNAME) {
            setIntraLoggedIn();
            navigate('/admin_intra', { replace: true });
        } else {
            setError('Väärä tunnus tai salasana.');
        }
    };

    return (
        <Container text>
            <style>{`.ui.form .field > label { color: whitesmoke; }`}</style>
            <Header as="h2">AsLAN Intra</Header>
            <Form className="intra-login-form" onSubmit={handleSubmit} error={!!error} style={{ width: '50%' }}>
                <Form.Input label="Tunnus" value={username} onChange={(_, { value }) => setUsername(value)} required />
                <Form.Input
                    type="password"
                    label="Salasana"
                    value={password}
                    onChange={(_, { value }) => setPassword(value)}
                    placeholder="Salasana"
                    required
                />
                {error && <Message error content={error} />}
                <Button type="submit" primary>
                    Kirjaudu
                </Button>
            </Form>
            <br />
            <br />
            <p style={{ color: 'whitesmoke' }}>not yet here...</p>
            <Link to={'/todo'} title="Todo">
                Todo
            </Link>
        </Container>
    );
};

export default IntraView;
